module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"user_display_name":"This is a review by <b>%{name}</b>."}}')
  delete Component.options._Ctor
}
